import { action } from 'typesafe-actions';
import { UIActionTypes } from './types';
import { ISectionProps, SectionId } from '../../components/molecules/Sidebar/types';
import { BiometricResidencePermitDoc } from '../../types';

export const updateTawkIsLoaded = (isTawkLoaded: boolean) => action(UIActionTypes.TOGGLE_TAWK_IS_LOADED, isTawkLoaded);

export const updateSections = (sections: ISectionProps[]) => action(UIActionTypes.UPDATE_SECTIONS, sections);
export const updateActiveSectionId = (sectionId: SectionId) =>
  action(UIActionTypes.UPDATE_ACTIVE_SECTION_ID, { sectionId });

export const openDocumentModal = (
  sponsorType: string,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  isInfoOnly: boolean,
  modalTitle?: string
) =>
  action(UIActionTypes.OPEN_DOCUMENT_MODAL, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    isInfoOnly,
    modalTitle
  });

export const openFinanceDocumentModal = (
  sponsorType: string,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  isInfoOnly: boolean,
  modalTitle?: string
) =>
  action(UIActionTypes.OPEN_FINANCE_DOCUMENT_MODAL, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    isInfoOnly,
    modalTitle
  });

export const openFollowUpDocumentModal = (
  sponsorType: string,
  sponsorKey: string | null,
  docType: string,
  docKey: string,
  modalTitle: string,
  fileNames: string[],
  isComplete: boolean,
  biometricResidencePermit?: BiometricResidencePermitDoc
) =>
  action(UIActionTypes.OPEN_FOLLOW_UP_DOCUMENT_MODAL, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    modalTitle,
    fileNames,
    isComplete,
    biometricResidencePermit
  });

export const closeModal = () => action(UIActionTypes.CLOSE_MODAL);

export const openUploadModal = (
  sponsorType: string | null,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  modalTitle: string,
  fileNames: string[],
  metadata?: any
) =>
  action(UIActionTypes.OPEN_UPLOAD_MODAL, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    modalTitle,
    fileNames,
    metadata
  });

export const openUploadFinanceModal = (
  sponsorType: string,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  modalTitle: string,
  fileNames: string[],
  metadata?: any
) =>
  action(UIActionTypes.OPEN_FINANCE_UPLOAD_MODAL, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    modalTitle,
    fileNames,
    metadata
  });

export const openUploadFollowUpModal = (
  sponsorType: string,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  modalTitle?: string,
  fileNames?: string[],
  metadata?: any
) =>
  action(UIActionTypes.OPEN_FOLLOW_UP_UPLOAD_MODAL, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    modalTitle,
    fileNames,
    metadata
  });

export const toggleTaskMenu = (isOpen: boolean) => action(UIActionTypes.TOGGLE_TASK_MENU, { isOpen });

export const updateInitNotificationsShown = (isShown: boolean) =>
  action(UIActionTypes.UPDATE_INIT_NOTIFICATIONS_SHOWN, isShown);

export const setIsLoading = (isLoading: boolean) =>
  action(UIActionTypes.SET_IS_LOADING, {
    isLoading
  });

export const setContextLoading = isLoading => action(UIActionTypes.SET_CONTEXT_LOADING, { isLoading });
export const setContextSuccess = () => action(UIActionTypes.SET_CONTEXT_SUCCESS);
